import { t } from 'i18next'
import React from 'react'
import { Action, IOWidget, mk_widget } from 'widgets-for-react'
import { Acf } from '../../../../../wp_types'
import { any } from 'widgets-for-react/dist/combinators/any'
import { async, AsyncState, loadingAsyncState } from 'widgets-for-react/dist/combinators/async'
import { stateful } from 'widgets-for-react/dist/combinators/stateful'
import { getClassName } from '../../../../cms/blocks/utils.gen'
import { TemplateState } from '../../../../cms/page/types.gen'
import * as BSLEvents from '../../../../events/api'
import { CustomBlock } from '../../../../wordpress/types_and_parser/custom_blocks.gen'
import { Block } from '../../../../wordpress/types_and_parser/standard_blocks.gen'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { DataLayer } from '../../../utils/datalayer'
import { CustomBlockData } from '../types.mod'

export type BSLEventOverviewBlockProps = {
  key?: string
  category: string
  page_size: Acf.Number
  title: Acf.Text
}

type BSLEventOverviewBlockState = {
  events: AsyncState<BSLEvents.Event[]>
  current_page: number
}

export type BSLEventOverviewBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  title_classname: string
  subtitle_classname: string
  list_classname: string
  item_classname: string
  item_link_classname: string
  item_label_classname: string
  item_title_classname: string
  item_title_text_classname: string
  item_date_classname: string
  item_text_classname: string
  item_icon_classname: string
  clickable_primary_classname: string
}>

export function BSLEventOverviewBlock<customBlockData, extra_images>(
  props: BSLEventOverviewBlockProps,
  options?: { style?: BSLEventOverviewBlockStyle; key?: string }
): IOWidget<
  TemplateState<CustomBlockData, CustomBlock, Block, extra_images, PublicSite_CustomPageData>,
  Action<TemplateState<CustomBlockData, CustomBlock, Block, extra_images, PublicSite_CustomPageData>>
> {
  const { page_size, title } = props

  return (s: TemplateState<CustomBlockData, CustomBlock, Block, extra_images, PublicSite_CustomPageData>) =>
    stateful<BSLEventOverviewBlockState>()(s0 =>
      any<Action<BSLEventOverviewBlockState>>()([
        async<BSLEvents.Event[]>()(s0.events).map(a => s1 => ({ ...s1, events: a(s1.events) })),
        mk_widget({
          run: setState => {
            
            if (s0.events.kind == 'loaded' && s0.events.value.length <= 0) {
              return <></>
            }

            return (
              <section
                className={getClassName(options, 'block_classname', 'block')}
                key={options && options.key ? options.key : ''}
              >
                
                <h2>{title}</h2><br />
                
                
                <div className={getClassName(options, 'inner_classname', 'block__inner')}>
                  {s0.events.kind === 'loaded' ? (
                    <ul className={getClassName(options, 'list_classname', '')}>
                      
                      {s0.events.value
                      
                        .slice(page_size * s0.current_page, page_size * s0.current_page + page_size)
                        .map((event, key) => (
                          <li className={getClassName(options, 'item_classname', '')} key={`event-${key}`}>
                            <a
                              href={event.link}
                              target="_blank"
                              className={getClassName(options, 'item_link_classname', '')}
                              onClick={() => DataLayer.clickToEvent(event.link)}
                            >
                              <span className={getClassName(options, 'item_label_classname', '')}>
                                {t('events.sources.' + event.source)}
                              </span>
                              <h2 className={getClassName(options, 'item_title_classname', '')}>
                                <span className={getClassName(options, 'item_title_text_classname', '')}>
                                  {event.title}
                                </span>
                              </h2>
                              {event.startDate.toString().length > 0 ? (
                                <time
                                  dateTime={event.startDate.format()}
                                  className={getClassName(options, 'item_date_classname', '')}
                                >
                                  <span>{event.startDate.format('D')}</span>
                                  <span>{event.startDate.localeData().monthsShort(event.startDate, '-MMM-')}</span>
                                 
                                </time>
                              ) : <></>}
                              {event.location.toString().length > 0 ? (
                                <p className={getClassName(options, 'item_text_classname', '')}>
                                  <svg
                                    aria-hidden="true"
                                    width="13"
                                    height="13"
                                    className={getClassName(options, 'item_icon_classname', '')}
                                  >
                                    <use xlinkHref="#icon--marker" />
                                  </svg>
                                  <span>{event.location}</span>
                                </p>
                              ) : <></>}
                            </a>
                          </li>
                        ))}
                    </ul>
                  ) : (
                    <div>
                      <div className="svg-loader svg-loader--nobg">
                        <svg viewBox="0 0 40 40" className="svg-loader__svg">
                          <path
                            fill="#ccc"
                            className="svg-loader__background"
                            d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
                                    s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
                                    c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"
                          />
                          <path
                            fill="#000"
                            className="svg-loader__foreground"
                            d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z"
                          >
                            <animateTransform
                              attributeType="xml"
                              attributeName="transform"
                              type="rotate"
                              from="0 20 20"
                              to="360 20 20"
                              dur="0.9s"
                              repeatCount="indefinite"
                            />
                          </path>
                        </svg>
                      </div>
                    </div>
                  )}
                  {s0.events.kind === 'loaded' ? (
                    <div className="buttons">
                      {s0.current_page > 0 && (
                        <button
                          className="link"
                          onClick={_ => setState(s => ({ ...s, current_page: s.current_page - 1 }))}
                        >
                          {t('pagination.earlier_events')}
                        </button>
                      )}
                      {s0.current_page < Math.floor(s0.events.value.length / page_size) && (
                        <button
                          className="link"
                          onClick={_ => setState(s => ({ ...s, current_page: s.current_page + 1 }))}
                        >
                          {t('pagination.later_events')}
                        </button>
                      )}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </section>
            )
          }
        })
      ]).map(a => a(s0))
    )({ events: loadingAsyncState(() => BSLEvents.getEvents(props.category)), current_page: 0 }).map(a => s => s)
}
